import { Component, OnInit, NgModule, Input } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AgmCoreModule } from '@agm/core';
import { LocationService } from '../../../services/location.service';
import { MapsAPILoader } from '@agm/core';
import {MouseEvent} from '@agm/core';
import {Direccion} from '../../../models/direccion';
import {Visita} from '../../../models/visita';
import { SimpleChanges } from '@angular/core';
/*
    Este componente es el encargado de mostrar un mapa de Google para poder trabajar con la api
*/
@Component({
  selector: 'app-select-map-direction',
  templateUrl: './select-map-direction.component.html',
  styleUrls: ['./select-map-direction.component.scss']
})
export class SelectMapDirectionComponent implements OnInit
{
  constructor(private LocationService: LocationService) {}
  lat = 0;
  lng = 0;
  zoom = 15;
  geocoder = new google.maps.Geocoder();
  direccion: Direccion;

  @Input() visita: Visita ;
  @Input() callFrom: string;

  markers: Marker[] = [];

  ngOnInit()
  {
    if(this.callFrom != "tasacion") {
      this.LocationService.getPosition().then(pos => this.startMap(pos));
    } else {
      this.runGeocoding();
    }
    
    this.direccion = new Direccion();
    if (this.visita != null)
    {
      this.direccion.altura = this.visita.altura;
      this.direccion.bloque = this.visita.bloque;
      this.direccion.calle = this.visita.calle;
      this.direccion.letra = this.visita.letra;
      this.direccion.numero = this.visita.numero;
    }
    else
    {
      console.error('visita es nulo' );
    }
  }

  startMap(pos: any)
  {
    this.lat = pos.lat;
    this.lng = pos.lng;
    this.markers.push({
      lat: pos.lat,
      lng: pos.lng,
      draggable: true
    });
  }

  //Esta funcion llama al geocoder.geocode que e suna funcion Callback por lo que hay que esperar
  //A que responda para que el programa no continue sin que acabe. Para esperar ejecutamos la funcion
  //dentro de un promise para que espere la respuesta
  getDirection(): Promise<Direccion>
  {
    return new Promise<Direccion>(resolve  => {
      //Recogemos la primera marca del mapa (sol odebe haber una)
      const mark = this.markers[0];
      let street = 'No encontrado';
      //El objeto que pasaremos a la API de google con la informacion de la amrca
      const latlng =
      {
        lat: mark.lat,
        lng: mark.lng,
      };
      //Llamamos a la api de google que es async
      this.geocoder.geocode({ location: latlng }, (results, status) =>
        {
          if (status === 'OK')
          {
            if (results[0])
            {
              //Recogemos el nombre de la calle
              street = results[0].formatted_address;
              const res = street.split(',');
              this.direccion.calle = res[0];
              this.direccion.numero = res[1];
              //Devuelve la direccion cuando este lista
              resolve(this.direccion);
            }
            else
            {
              alert('No results found');
            }
          }
          else
          {
            alert('Geocoder failed due to: ' + status);
          }
        });
    });
  }


  mapClicked($event: any) {
    if(this.callFrom != "tasacion") { 
    //si tiene amrcadores los borramos para que solo haya uno
    if (this.markers.length !== 0)
    {
      this.markers = [];
    }
    this.markers.push({
      lat: $event.coords.lat,
      lng: $event.coords.lng,
      draggable: true
    });
    }
  }

  markerDragEnd(m: Marker, $event: MouseEvent)
  {
    m.lat = $event.coords.lat;
    m.lng = $event.coords.lng;
  }

  //Si hacemos clic en el marcador lo borramos
  clickedMarker(label: string, index: number)
  {
    //this.markers = [];
  }

  runGeocoding() {
    if(this.visita.idTasacion) {
        // 1. Initialize GeoCoder
        const geocoder = new google.maps.Geocoder();
        // 2. The text address that you want to convert to coordinates
        let address = this.visita.calle+" "+this.visita.numero+" "+this.visita.bloque+" "+this.visita.altura+" "+this.visita.letra;
        // 3. Obtain coordinates from the API
        this.geocoder.geocode({ address: address }, (results, status) => {
        if (status === "OK") {
          // Display response in the console
          this.markers = [];
          this.startMap({lat:results[0].geometry.location.lat(),lng:results[0].geometry.location.lng()});
        } else {
          console.log("Geocode error: " + status);
        }
    });
    }
  }
  
  ngOnChanges() {
    if(this.callFrom == "tasacion") {
      this.runGeocoding();
    }
  }

}

interface Marker
{
  lat: number;
  lng: number;
  label?: string;
  draggable: boolean;
}
